// Reasons the BE's Zone Storage → Portal bridges can answer with, mapped to
// the i18n key the screen shows:
//   • Sorter 2 → Portal dispatch (jli-portal-be app/zoneStorage/services/zoneDispatch.js):
//     the opening tag pre-check (/zonestorage/orders/check-tag) and the
//     closing scan (mark-collected), plus the singles lane close.
//   • Unsold Reauction → Portal stock move (services/reauctionMove.js):
//     the Sorter 1 reauction tote endpoints (/zonestorage/reauction/*) and
//     the conveyor Add Pallet check (409 { ok:false, reason }).
// Anything unrecognised reads as a generic scan failure.
export const zoneDispatchReasonKey = (reason?: string | null): string => {
    switch (reason) {
        case "not_a_tote":          return "zone_tag_not_a_tote";
        case "tote_unavailable":    return "zone_tag_unavailable";
        case "tote_bound":          return "zone_tag_bound";
        case "tote_in_use":         return "zone_tag_in_use";
        case "locked":              return "zone_tote_locked";
        case "order_not_in_portal": return "zone_order_not_in_portal";
        case "ambiguous_order":     return "zone_order_ambiguous";
        case "order_not_ready":     return "zone_order_not_ready";
        case "items_mismatch":      return "zone_items_mismatch";
        case "allocation_failed":   return "zone_allocation_failed";
        case "order_has_no_items":  return "zone_order_no_items";
        case "tote_not_mapped":     return "zone_reauction_tote_not_mapped";
        case "sku_unknown":         return "zone_reauction_not_portal_item";
        case "bay_already_mapped":  return "zone_reauction_bay_mapped";
        case "disabled":            return "zone_reauction_disabled";
        default:                    return "scan_failed";
    }
};
